import {ComponentRegistry} from '../../components/component-registry';
import {DataApi} from '../../api/data-api/data-api';
import {AbstractGroup} from '../abstract-group';
import {PublicationFilter, PublicationSettings} from './filter';

/**
 * Publication picker.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export class Picker extends AbstractGroup<PublicationFilter, PublicationSettings> {
  constructor(container: HTMLElement) {
    super(container);
    this.find();
    ComponentRegistry.add('publication-picker', this);
  }

  /**
   * Finds picked publications.
   */
  protected find(): void {
    DataApi.instance.publicationEndpoint.find(this.settings, null)
      .then(response => {
        if (this.isResultEmpty(response)) {
          this.empty();
          return;
        }
        this.notEmpty();

        let html = '';
        for (const document of response.documents) {
          const template = require('../../handlebars/templates/publication/picker-item.handlebars');
          html += template({
            document: document
          });
        }
        this.update(html);

        this.emitter.emit('change', this);
      })
      .catch(e => {
        this.error(e);
      });
  }
}
